import { get } from 'lodash';

export const verifyReturnUrl = (res, cb) => {
  const returnUrl = get(res, 'data.data.returnUrl', get(res, 'state.data.returnUrl'));
  const redirectUrl = get(res, 'data.data.redirectUrl', get(res, 'state.data.redirectUrl'));

  if (returnUrl) window.open(returnUrl, '_self');
  else if (redirectUrl) window.open(redirectUrl, '_self');
  else if (cb) cb(res);
};
